"use client";
import NotFound from "@/app/not-found";
import RegisterEmail from "@/components/auth/Register/RegisterEmail";
import { useSettings } from "@/context/settingsContext";
import { getSettingValue } from "@/utils/utils";

const page = () => {
  const { settings } = useSettings();
  const accountCreation = getSettingValue(settings, "account_creation");
  return (
    <>
      {accountCreation === "1" ? (
        <RegisterEmail />
      ) : (
        <div>
          <NotFound />
        </div>
      )}
    </>
  );
};

export default page;
